import { Base64 } from '../../../util/Base64';
import {
  ReportRealTimeResult,
  ReportRealTimeSpec,
} from './ReportRealTime.model';
import ReportAPI from './ReportAPI';

export const ReportRealTimeAPI = ReportAPI.injectEndpoints({
  endpoints: (build) => ({
    getReportsRealtimeByGroupId: build.query<
      ReportRealTimeResult,
      { groupId: string; spec: ReportRealTimeSpec }
    >({
      query: ({ groupId, spec }) => ({
        // FIXME: use deviceId
        url: `/group/${Base64.encode(groupId)}/report`,
        invalidatesTags: ['report'],
        data: spec,
        method: 'POST',
      }),
    }),
  }),
});

export default ReportRealTimeAPI;
